
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://7a9fb784e87147fc95d5bb803cded6f8@sentry.haltu.net/47',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
